export default __webpack_public_path__ + "static/media/idcheck.048682b8.gif";